import { useState } from "react";
import { testimonials } from "@/mocks/homeData";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-amber-300 text-amber-700 text-xs font-semibold tracking-widest uppercase mb-4">
            Student Success Stories
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Real Students. Real Results.
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Sidebar — student list */}
          <div className="flex flex-row lg:flex-col gap-3 lg:w-64 flex-shrink-0 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {testimonials.map((t2, i) => (
              <button
                key={t2.id}
                onClick={() => setActive(i)}
                className={`flex items-center gap-3 p-3 rounded-xl border transition-all duration-200 cursor-pointer whitespace-nowrap lg:whitespace-normal text-left min-w-[200px] lg:min-w-0 ${
                  active === i
                    ? "border-amber-400 bg-amber-50"
                    : "border-gray-100 bg-white hover:border-gray-200"
                }`}
              >
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden">
                  <img src={t2.avatar} alt={t2.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900">{t2.name}</div>
                  <div className="text-xs text-gray-400">{t2.score}</div>
                </div>
              </button>
            ))}
          </div>

          {/* Main testimonial */}
          <div className="flex-1 bg-amber-50 rounded-3xl p-8 md:p-10 relative">
            <div className="text-7xl text-amber-200 font-serif leading-none mb-4 select-none">&ldquo;</div>
            <p className="text-gray-700 text-lg leading-relaxed mb-8 -mt-6">
              {t.quote}
            </p>

            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="font-bold text-gray-900">{t.name}</div>
                <div className="text-amber-600 text-sm font-semibold">{t.school}</div>
                <div className="text-gray-400 text-xs">{t.grade} &bull; {t.score}</div>
              </div>
              <div className="ml-auto flex items-center gap-1 bg-gray-900 rounded-full px-3 py-1.5">
                <i className="ri-star-fill text-amber-400 text-xs"></i>
                <span className="text-white text-xs font-bold">5.0</span>
              </div>
            </div>

            {/* Nav arrows */}
            <div className="absolute bottom-8 right-8 flex gap-2">
              <button
                onClick={() => setActive((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 bg-white hover:bg-gray-50 cursor-pointer transition-colors"
              >
                <i className="ri-arrow-left-line text-gray-600"></i>
              </button>
              <button
                onClick={() => setActive((prev) => (prev + 1) % testimonials.length)}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-900 text-white hover:bg-gray-700 cursor-pointer transition-colors"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        {/* School logos strip */}
        <div className="mt-14 text-center">
          <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold mb-6">
            Our students have been admitted to
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {["Harvard", "MIT", "Yale", "Stanford", "Princeton", "Columbia", "Oxford", "Cambridge", "UPenn", "Cornell"].map((school) => (
              <span
                key={school}
                className="px-4 py-2 rounded-full bg-gray-100 text-gray-600 text-xs font-semibold"
              >
                {school}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
